module.exports = __webpack_public_path__ + "static/img/platform-4.d7fd91d6.png";